export default {
  title: 'Betal med PayPal',
  error: 'PayPal-betalingen kunne ikke gennemføres. Prøv igen.',
};
